import httpService from './httpService';
import { audioListUrl } from '../constants/apiEndPoints';

export function listAudiosListAPI() {
    return httpService.get(audioListUrl);
}
